import React, { Component } from 'react';
import { comma } from '../../lib/util/numberUtil';
import { paymentMethodString } from '../../lib/util/codeUtil';
import _ from 'lodash';
import '../../css/modal.scss';
import CloseIcon from '../../img/body/close.png';

class PayChangeDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupList: [],
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { data } = this.props;

    if (prevProps.isOpen !== this.props.isOpen && data) {

      const groupList = _(data.orderPayments)
        .groupBy('groupKey')
        .map((orderPayments, id) => ({
          groupKey: id,
          updateDate: _.first(orderPayments).updateDate,
          orderPayments,
        }))
        .value();

      this.setState({
        groupList,
      });
    }
  }

  render() {
    const { data, isOpen, close } = this.props;

    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-detail-overlay" onClick={close} />

            <div className="Modal-detail paymentchange">
              {/* 타이틀 */}
              <div className="paymentchange-title">
                <div>결제변경내역 상세보기</div>
                <div className="close">
                  <img
                    style={{ display: 'inline' }}
                    onClick={close}
                    src={CloseIcon}
                    alt=""
                  />
                </div>
              </div>

              <div className="paymentchange-content-modal">
                <div className="paymentchange-element-all">
                  <div className="paymentchange-element-block">
                    <div className="paymentchange-element-block-menu">
                      <ul>
                        <li>변경시간</li>
                        <li>결제내역</li>
                      </ul>
                    </div>
                  </div>
                  <div className="paymentchange-element-block-field-wrapper">
                    {(!this.state.groupList || this.state.groupList.length) ===
                      0 && (
                      <div style={{ textAlign: 'center', padding: '50px' }}>
                        내역이 없습니다.
                      </div>
                    )}

                    {this.state.groupList &&
                      this.state.groupList.map((row, index) => (
                        <div
                          key={index}
                          className="paymentchange-element-block-field">
                          <ul>
                            <li> {row.updateDate}</li>
                            <li>
                              {' '}
                              {row.orderPayments.map((el) => {
                                return (
                                  <div
                                    className="paymentchange-detail"
                                    key={el.paymentMethod}>
                                    {paymentMethodString[el.paymentMethod]} :{' '}
                                    {comma(el.paymentAmount)} 원
                                  </div>
                                );
                              })}
                            </li>
                          </ul>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default PayChangeDialog;
